import React from 'react';

import { 
  Container, 
  Row, 
  Col 
} from "react-grid-system";

import { 
  Collapse, 
  FormGroup,
  Input 
} from 'reactstrap';

import * as Constants from './Constants.js';

// Icons
import { FaChevronCircleDown, FaChevronCircleUp } from "react-icons/fa";

class Settings extends React.Component {
  
  constructor(props) {
    super(props);
    this.settingsRef = React.createRef();
    this.dividerRef = React.createRef();
  }
  
  componentDidMount() {
    //console.log("Settings - componentDidMount");
  }
  
  toggleSettings = (category) => {
    //console.log("toggleSettings - old", this.state.hideshow);
    let newHideshow = this.props.currentDesign.hideshow;
    newHideshow[category] = !newHideshow[category];
    let newDesign = {...this.props.currentDesign};
    newDesign.hideshow = newHideshow;
    //console.log("toggleSettings - new", newHideshow);
    this.props.updateDesign(newDesign);
  }
  
  handleGenomeClick = (event) => {
    const target = event.target;
    var newSample = null;
    if (Constants.epilogosMemeStateModelAvailability[target.value][this.props.currentDesign.stateModel]) {
      switch(this.props.currentDesign.stateModel) {
        case Constants.epilogosMemeStateModelObserved:
          newSample = Constants.epilogosMemeDefaultObservedSample[target.value];
          break;
        case Constants.epilogosMemeStateModelObservedAux:
          newSample = Constants.epilogosMemeDefaultObservedAuxSample[target.value];
          break;
        case Constants.epilogosMemeStateModelImputed:
          newSample = Constants.epilogosMemeDefaultImputedSample[target.value];
          break;
        default:
          break;
      }
    }
    else {
      var newModel = Constants.epilogosMemeDefaultStateModel[target.value];
      switch(newModel) {
        case Constants.epilogosMemeStateModelObserved:
          newSample = Constants.epilogosMemeDefaultObservedSample[target.value];
          break;
        case Constants.epilogosMemeStateModelObservedAux:
          newSample = Constants.epilogosMemeDefaultObservedAuxSample[target.value];
          break;
        case Constants.epilogosMemeStateModelImputed:
          newSample = Constants.epilogosMemeDefaultImputedSample[target.value];
          break;
        default:
          break;
      }
    }

    let newDesign = {...this.props.currentDesign};
    newDesign.genome = target.value;
    newDesign.stateModel = Constants.epilogosMemeDefaultStateModel[target.value];
    newDesign.sample = newSample;
    document.activeElement.blur();
    this.props.updateDesign(newDesign);
  }
  
  handleStateModelClick(event) {
    //console.log("event.target.value", event.target.value);
    var currentSample = this.props.currentDesign.sample;
    var newStateModel = event.target.value;
    var newSampleObjs = null;
    switch (newStateModel) {
        case Constants.epilogosMemeStateModelObserved:
          newSampleObjs = Constants.epilogosMemeObservedSamples[this.props.currentDesign.genome];
          break;
        case Constants.epilogosMemeStateModelObservedAux:
          newSampleObjs = Constants.epilogosMemeObservedAuxSamples[this.props.currentDesign.genome];
          break;
        case Constants.epilogosMemeStateModelImputed:
          newSampleObjs = Constants.epilogosMemeImputedSamples[this.props.currentDesign.genome];
          break;
        default:
          throw new Error('Unknown state model for retrieving sample objects array');
          break;
    };
    var currentSampleInNewSampleObjs = false;
    for (var sampleObj in newSampleObjs) {
      var k = Object.keys(sampleObj)[0];
      if (k === currentSample) {
        currentSampleInNewSampleObjs = true;
        break;
      }
    }
    var newSample = currentSample;
    if (!currentSampleInNewSampleObjs) {
      switch (newStateModel) {
        case Constants.epilogosMemeStateModelObserved:
          newSample = Constants.epilogosMemeDefaultObservedSample[this.props.currentDesign.genome];
          break;
        case Constants.epilogosMemeStateModelObservedAux:
          newSample = Constants.epilogosMemeDefaultObservedAuxSample[this.props.currentDesign.genome];
          break;
        case Constants.epilogosMemeStateModelImputed:
          newSample = Constants.epilogosMemeDefaultImputedSample[this.props.currentDesign.genome];
          break;
        default:
          throw new Error('Unknown state model used for assigning new sample');
          break;
      };
    }
    if (typeof newSample !== 'string') {
      newSample = Constants.epilogosMemeDefaultObservedSample[this.props.currentDesign.genome];
    }

    let newDesign = {...this.props.currentDesign};
    newDesign.stateModel = newStateModel;
    newDesign.sample = newSample;
    document.activeElement.blur();
    this.props.updateDesign(newDesign);
  }
  
  handleInputChange = (event, customName, mouseoutFlag) => {
    const target = event.target;
    const value = (mouseoutFlag) ? null : (target.type === 'checkbox') ? target.checked : target.value;
    const name = (customName) ? customName : target.name;

    let newDesign = {...this.props.currentDesign};
    newDesign[name] = value;
    if ((target.type === 'button') || (target.type === 'select-one')) { document.activeElement.blur(); }
    this.props.updateDesign(newDesign);
  }
  
  handleSiteDistributionClick(event) {
    let newDesign = {...this.props.currentDesign};
    newDesign.siteDistribution = event.target.value;
    document.activeElement.blur();
    this.props.updateDesign(newDesign);
  }
  
  handleBackgroundClick(event) {
    let newDesign = {...this.props.currentDesign};
    newDesign.background = event.target.value;
    document.activeElement.blur();
    this.props.updateDesign(newDesign);
  }
  
  handlePriorClick(event) {
    let newDesign = {...this.props.currentDesign};
    newDesign.prior = event.target.value;
    document.activeElement.blur();
    this.props.updateDesign(newDesign);
  }
  
  onClickSettingsButton = (event) => {
    //console.log("event.target.name", event.target.name);
    if (event.target.name === "genome") {
      this.handleGenomeClick(event);
    }
    else if (event.target.name === "stateModel") {
      this.handleStateModelClick(event);
    }
    else if (event.target.name === "siteDistribution") {
      this.handleSiteDistributionClick(event);
    }
    else if (event.target.name === "background") {
      this.handleBackgroundClick(event);
    }
    else if (event.target.name === "prior") {
      this.handlePriorClick(event);
    }
  }
  
  genomeSectionBody = () => {
    let activeGenome = this.props.currentDesign.genome;
    let kButtons = [];
    let kButtonIdx = 0;
    Object.keys(Constants.epilogosMemeGenomesForSettings).forEach(k => {
      let kButtonLabels = Constants.epilogosMemeGenomesForSettings[k];
      const kButtonPrefix = 'genome-bg-btn-';
      const kButtonParentPrefix = 'genome-bg-parent-btn-';
      kButtonLabels.forEach((label) => {
        const isActive = (activeGenome === label);
        const isDisabled = false;
        let kButtonKey = kButtonPrefix + kButtonIdx;
        let kButtonParentKey = kButtonParentPrefix + kButtonIdx;
        let formattedLabel = <span style={{fontWeight:(isActive)?600:100}}>{label}</span>;
        kButtons.push(<div key={kButtonParentKey}><input id={kButtonKey} key={kButtonKey} type="radio" checked={isActive} disabled={isDisabled} name="genome" value={label} onChange={()=>{}} onClick={(e)=>{this.onClickSettingsButton(e)}} />{' '}<label className="form-label" htmlFor={kButtonKey}>{formattedLabel}</label></div>);
        kButtonIdx++;
      });
    });
    const kSectionBodyKey = 'genome-sb';
    return <FormGroup key={kSectionBodyKey} check className="form-group-radio">{kButtons}</FormGroup>;
  }
  
  modelSectionBody = () => {
    let activeGenome = this.props.currentDesign.genome;
    let activeModel = this.props.currentDesign.stateModel;
    let result = [];
    let kButtons = [];
    const kButtonPrefix = 'model-bg-btn-';
    const kButtonParentPrefix = 'model-bg-parent-btn-';
    let kButtonIdx = 0;
    Object.keys(Constants.epilogosMemeModelsForGenomes[activeGenome]).forEach(k => {
      if (Constants.epilogosMemeModelsForGenomes[activeGenome][k].visible) {
        const isActive = (activeModel === k);
        const isDisabled = !Constants.epilogosMemeModelsForGenomes[activeGenome][k].enabled;
        const kLabel = Constants.epilogosMemeModelsForGenomes[activeGenome][k].titleText;
        const kValue = Constants.epilogosMemeModelsForGenomes[activeGenome][k].value;
        let kButtonKey = kButtonPrefix + kButtonIdx;
        let kButtonParentKey = kButtonParentPrefix + kButtonIdx;
        let formattedKLabel = <span style={{fontWeight:(isActive)?600:100}}>{kLabel}</span>;
        kButtons.push(<div key={kButtonParentKey}><input id={kButtonKey} key={kButtonKey} type="radio" checked={isActive} disabled={isDisabled} name="stateModel" value={kValue} onChange={()=>{}} onClick={(e)=>{this.onClickSettingsButton(e)}} />{' '}<label className="form-label" htmlFor={kButtonKey}>{formattedKLabel}</label></div>);
        kButtonIdx++;
      }
    });
    const kButtonGroupPrefix = 'model-bg-';
    let kButtonGroupIdx = 0;
    const kButtonGroupKey = kButtonGroupPrefix + kButtonGroupIdx;
    result.push(<span key={kButtonGroupKey}>{kButtons}</span>);
    const kSectionBodyKey = 'model-sb';
    return <div className="drawer-settings-section-body-content"><FormGroup key={kSectionBodyKey} check>{result}</FormGroup></div>;
  }
  
  sampleSectionBody = (genome, model) => {
    switch (model) {
      case Constants.epilogosMemeStateModelObserved:
        return Constants.epilogosMemeObservedSamples[genome].map(this.makeOptionFromObjectArray, "sample");
      case Constants.epilogosMemeStateModelObservedAux:
        return Constants.epilogosMemeObservedAuxSamples[genome].map(this.makeOptionFromObjectArray, "sample");
      case Constants.epilogosMemeStateModelImputed:
        return Constants.epilogosMemeImputedSamples[genome].map(this.makeOptionFromObjectArray, "sample");
      default:
        return null;
    }
  };
  
  siteDistributionSectionBody = () => {
    let activeSiteDistribution = this.props.currentDesign.siteDistribution;
    let kButtons = [];
    const kButtonPrefix = 'siteDistribution-bg-btn-';
    const kButtonParentPrefix = 'siteDistribution-bg-parent-btn-';
    let kButtonIdx = 0;
    Object.keys(Constants.epilogosMemeMotifSiteDistributions).forEach(k => {
      const isActive = (activeSiteDistribution === k);
      const isDisabled = false;
      const kLabel = Constants.epilogosMemeMotifSiteDistributions[k];
      const kValue = k;
      let kButtonKey = kButtonPrefix + kButtonIdx;
      let kButtonParentKey = kButtonParentPrefix + kButtonIdx;
      let formattedKLabel = <span style={{fontWeight:(isActive)?600:100}}>{kLabel}</span>;
      kButtons.push(<div key={kButtonParentKey}><input id={kButtonKey} key={kButtonKey} type="radio" checked={isActive} disabled={isDisabled} name="siteDistribution" value={kValue} onChange={()=>{}} onClick={(e)=>{this.onClickSettingsButton(e)}} />{' '}<label className="form-label" htmlFor={kButtonKey}>{formattedKLabel}</label></div>);
      kButtonIdx++;
    });
    const kSectionBodyKey = 'siteDistribution-sb';
    return <FormGroup key={kSectionBodyKey} check>{kButtons}</FormGroup>;
  }
  
  backgroundSectionBody = () => {
    let activeBackground = this.props.currentDesign.background;
    let activeSample = this.props.currentDesign.sample;
    let kButtons = [];
    const kButtonPrefix = 'background-bg-btn-';
    const kButtonParentPrefix = 'background-bg-parent-btn-';
    let kButtonIdx = 0;
    Object.keys(Constants.epilogosMemeBackgrounds).forEach(k => {
      const isActive = (activeBackground === k);
      const isDisabled = false;
      let kLabel = Constants.epilogosMemeBackgrounds[k];
      const kValue = k;
      if (kValue === "zfs") { kLabel += ` (${activeSample})`; }
      let kButtonKey = kButtonPrefix + kButtonIdx;
      let kButtonParentKey = kButtonParentPrefix + kButtonIdx;
      let formattedKLabel = <span style={{fontWeight:(isActive)?600:100}}>{kLabel}</span>;
      kButtons.push(<div key={kButtonParentKey}><input id={kButtonKey} key={kButtonKey} type="radio" checked={isActive} disabled={isDisabled} name="background" value={kValue} onChange={()=>{}} onClick={(e)=>{this.onClickSettingsButton(e)}} />{' '}<label className="form-label" htmlFor={kButtonKey}>{formattedKLabel}</label></div>);
      kButtonIdx++;
    });
    const kSectionBodyKey = 'background-sb';
    return <FormGroup key={kSectionBodyKey} check>{kButtons}</FormGroup>;
  }
  
  priorSectionBody = () => {
    let activePrior = this.props.currentDesign.prior;
    let kButtons = [];
    const kButtonPrefix = 'prior-bg-btn-';
    const kButtonParentPrefix = 'prior-bg-parent-btn-';
    let kButtonIdx = 0;
    Object.keys(Constants.epilogosMemePriors).forEach(k => {
      const isActive = (activePrior === k);
      const isDisabled = false;
      let kLabel = Constants.epilogosMemePriors[k];
      const kValue = k;
      let kButtonKey = kButtonPrefix + kButtonIdx;
      let kButtonParentKey = kButtonParentPrefix + kButtonIdx;
      let formattedKLabel = <span style={{fontWeight:(isActive)?600:100}}>{kLabel}</span>;
      kButtons.push(<div key={kButtonParentKey}><input id={kButtonKey} key={kButtonKey} type="radio" checked={isActive} disabled={isDisabled} name="prior" value={kValue} onChange={()=>{}} onClick={(e)=>{this.onClickSettingsButton(e)}} />{' '}<label className="form-label" htmlFor={kButtonKey}>{formattedKLabel}</label></div>);
      kButtonIdx++;
    });
    const kSectionBodyKey = 'prior-sb';
    return <FormGroup key={kSectionBodyKey} check>{kButtons}</FormGroup>;
  }
  
  memeVersionSectionBody = () => {
    return Constants.epilogosMemeMemeVersions.map(this.makeOptionFromVersionArray, "memeVersion");
  }
  
  makeOptionFromObjectArray = (o, n) => {
    let k = Object.keys(o)[0];
    return <option name={n} key={k} value={k}>{k} - {o[k]}</option>;
  };
  
  makeOptionFromVersionArray = (o, n) => {
    let k = Object.keys(o)[0];
    return <option name={n} key={k} value={k}>{o[k]}</option>;
  };
  
  render() { 
    
    return (
      <div ref={this.settingsRef}>
        
        <Container fluid style={{"paddingLeft":"20px", "paddingRight":"20px", "paddingBottom":"30px"}}>
          <Row nogutter>
          
            { /* left column */ }
            <Col sm={4} style={{"paddingRight":"10px"}}>
            
              <div key="viewer-genome-section" className="drawer-settings-section drawer-settings-section-middle">
                <div key="viewer-genome-section-header" className="drawer-settings-section-header">
                  <div key="viewer-genome-section-header-text" className="drawer-settings-section-header-text">Genome</div>
                </div>
                <div key="viewer-genome-section-body" className="drawer-settings-section-body">
                  {this.genomeSectionBody()}
                </div>
              </div>
              
            </Col>
            
            { /* middle column */ }
            <Col sm={4} style={{"paddingLeft":"10px","paddingRight":"10px"}}>
            
              <div key="viewer-model-section" className="drawer-settings-section drawer-settings-section-middle">
                <div key="viewer-model-section-header" className="drawer-settings-section-header">
                  <div key="viewer-model-section-header-text" className="drawer-settings-section-header-text">State model</div>
                </div>
                <div key="viewer-model-section-body" className="drawer-settings-section-body">
                  {this.modelSectionBody()}
                </div>
              </div>
              
            </Col>
            
            { /* right column */ }
            <Col sm={4} style={{"paddingLeft":"10px"}}>
            
              <div key="viewer-sample-section" className="drawer-settings-section drawer-settings-section-middle">
                <div key="viewer-sample-section-header" className="drawer-settings-section-header">
                  <div key="viewer-sample-section-header-text" className="drawer-settings-section-header-text">Epigenome</div>
                </div>
                <div key="viewer-sample-section-body" className="drawer-settings-section-body">
                  <Input type="select" name="sample" value={this.props.currentDesign.sample} onChange={this.handleInputChange}>{this.sampleSectionBody(this.props.currentDesign.genome, this.props.currentDesign.stateModel)}</Input>
                </div>
              </div>
                            
            </Col> 
            
          </Row>
          
        </Container>
        
        <Collapse isOpen={!this.props.currentDesign.hideshow.advancedOptions}>
          <Container fluid style={{"paddingLeft":"20px", "paddingRight":"20px", "paddingTop":"20px", "paddingBottom":"30px"}}>
            <Row nogutter>
              
              { /* left column */ }
              <Col sm={4} style={{"paddingRight":"10px"}}>
              
                <div key="viewer-siteDistribution-section" className="drawer-settings-section drawer-settings-section-middle">
                  <div key="viewer-siteDistribution-section-header" className="drawer-settings-section-header">
                    <div key="viewer-siteDistribution-section-header-text" className="drawer-settings-section-header-text">Site distributions</div>
                  </div>
                  <div key="viewer-siteDistribution-section-body" className="drawer-settings-section-body">
                    {this.siteDistributionSectionBody()}
                  </div>
                </div>
                
                <div key="viewer-background-section" className="drawer-settings-section drawer-settings-section-middle" style={{"paddingTop":"20px"}}>
                  <div key="viewer-background-section-header" className="drawer-settings-section-header">
                    <div key="viewer-background-section-header-text" className="drawer-settings-section-header-text">Background</div>
                  </div>
                  <div key="viewer-background-section-body" className="drawer-settings-section-body">
                    {this.backgroundSectionBody()}
                  </div>
                </div>
                                
              </Col>
              
              { /* center column */ }
              <Col sm={4} style={{"paddingLeft":"10px","paddingRight":"10px"}}>
              
                <div key="viewer-siteDistribution-section" className="drawer-settings-section drawer-settings-section-middle">
                  <div key="viewer-siteDistribution-section-header" className="drawer-settings-section-header">
                    <div key="viewer-siteDistribution-section-header-text" className="drawer-settings-section-header-text">Prior</div>
                  </div>
                  <div key="viewer-siteDistribution-section-body" className="drawer-settings-section-body">
                    {this.priorSectionBody()}
                  </div>
                </div>
              
              </Col>
              
              { /* right column */ }
              <Col sm={4} style={{"paddingLeft":"10px"}}>
              
                { /* 
                <div key="viewer-maxSize-section" className="drawer-settings-section drawer-settings-section-middle">
                  <div key="viewer-maxSize-section-header" className="drawer-settings-section-header">
                    <div key="viewer-maxSize-section-header-text" className="drawer-settings-section-header-text">Maximum size</div>
                  </div>
                  <div key="viewer-maxSize-section-body" className="drawer-settings-section-body">
                    <input id="max-size"
                      name="maxSize"
                      className="max-size-textfield panel-body-custom-input"
                      type="text"
                      value={this.state.maxSize}
                      onChange={this.handleInputChange} 
                      />
                  </div>
                </div>
                */ }
                
                <div key="viewer-motifNumber-section" className="drawer-settings-section drawer-settings-section-middle" style={{"paddingTop":"10px"}}>
                  <div key="viewer-motifNumber-section-header" className="drawer-settings-section-header">
                    <div key="viewer-motifNumber-section-header-text" className="drawer-settings-section-header-text">Motif number</div>
                  </div>
                  <div key="viewer-motifNumber-section-body" className="drawer-settings-section-body">
                    <input id="motif-number"
                      name="motifNumber"
                      className="motif-number-textfield panel-body-custom-input"
                      type="text"
                      value={this.props.currentDesign.motifNumber}
                      onChange={this.handleInputChange} 
                      />
                  </div>
                </div>
                
                <div key="viewer-motifMinimumWidth-section" className="drawer-settings-section drawer-settings-section-middle" style={{"paddingTop":"10px"}}>
                  <div key="viewer-motifMinimumWidth-section-header" className="drawer-settings-section-header">
                    <div key="viewer-motifMinimumWidth-section-header-text" className="drawer-settings-section-header-text">Motif minimum width</div>
                  </div>
                  <div key="viewer-motifMinimumWidth-section-body" className="drawer-settings-section-body">
                    <input id="motif-minw"
                      name="motifMinimumWidth"
                      className="motif-minw-textfield panel-body-custom-input"
                      type="text"
                      value={this.props.currentDesign.motifMinimumWidth}
                      onChange={this.handleInputChange} 
                      />
                  </div>
                </div>
                
                <div key="viewer-motifMaximumWidth-section" className="drawer-settings-section drawer-settings-section-middle" style={{"paddingTop":"10px"}}>
                  <div key="viewer-motifMaximumWidth-section-header" className="drawer-settings-section-header">
                    <div key="viewer-motifMaximumWidth-section-header-text" className="drawer-settings-section-header-text">Motif maximum width</div>
                  </div>
                  <div key="viewer-motifMaximumWidth-section-body" className="drawer-settings-section-body">
                    <input id="motif-maxw"
                      name="motifMaximumWidth"
                      className="motif-maxw-textfield panel-body-custom-input"
                      type="text"
                      value={this.props.currentDesign.motifMaximumWidth}
                      onChange={this.handleInputChange} 
                      />
                  </div>
                </div>
                
                <div key="viewer-memeVersion-section" className="drawer-settings-section drawer-settings-section-middle" style={{"paddingTop":"10px"}}>
                  <div key="viewer-memeVersion-section-header" className="drawer-settings-section-header">
                    <div key="viewer-memeVersion-section-header-text" className="drawer-settings-section-header-text">MEME version</div>
                  </div>
                  <div key="viewer-memeVersion-section-body" className="drawer-settings-section-body">
                    <Input type="select" name="memeVersion" value={this.props.currentDesign.memeVersion} onChange={this.handleInputChange}>{this.memeVersionSectionBody()}</Input>
                  </div>
                </div>
                
              </Col>
              
            </Row>
          </Container>
        </Collapse>
        
        <div ref={this.dividerRef} className="epilogos-content-hiw-divider-text">
          {(this.props.currentDesign.hideshow.advancedOptions?<span onClick={() => {
            this.toggleSettings("advancedOptions"); 
            setTimeout(()=>{this.dividerRef.current.scrollIntoView({behavior:'smooth', block:'center', inline:'center'})}, 1000);}}>Advanced options</span>:<span onClick={() => {this.toggleSettings("advancedOptions")}}>Hide advanced options</span>)}
          <br />
          <div style={{display:"block", width:"100%", height:"36px", textAlign:"center"}} onClick={(e) => {this.toggleSettings("advancedOptions"); setTimeout((e)=>{this.dividerRef.current.scrollIntoView({behavior:'smooth', block:'center', inline:'center'});}, 1000);}}>{(this.props.currentDesign.hideshow.advancedOptions?<FaChevronCircleDown className="epilogos-content-hiw-divider-widget" size="1.5em" />:<FaChevronCircleUp className="epilogos-content-hiw-divider-widget" size="1.5em" />)}</div>
        </div>
      
      </div>
    )
  }
}

export default Settings;